export const itemDetails = [
  { offset: "-140", to: "about", name: "About", num: "01 ", delay: "0.2" },
  { offset: "-140", to: "work", name: "Work", num: "02", delay: "0.25" },
  { offset: "-100", to: "project", name: "Project", num: "03", delay: "0.3" },
  { offset: "-140", to: "blog", name: "Blog", num: "04 ", delay: "0.35" },
  { offset: "-140", to: "contact", name: "Contact", num: "05 ", delay: "0.4" },
];
